import { render, staticRenderFns } from "./WpItemsViewPermissionsCard.vue?vue&type=template&id=629dfc29&"
import script from "./WpItemsViewPermissionsCard.vue?vue&type=script&lang=js&"
export * from "./WpItemsViewPermissionsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports